import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { Img, WmkImage } from "wmk-image";
import { SolutionSectionInt } from "./SolutionsSection";

const Wrap = styled.div`
  position: relative;
  display: block;
  top: 2rem;
  width: 30rem;
  height: 40rem;
  margin: auto;
  @media only screen and (max-width: 576px) {
    width: 20rem;
    height: 26.67rem;
  }
`;

const buttonPositions = [
  {
    x: "66%",
    y: "5%",
  },
  {
    x: "78%",
    y: "40%",
  },
  {
    x: "34%",
    y: "65%",
  },
  {
    x: "-5%",
    y: "40%",
  },
  {
    x: "8%",
    y: "5%",
  },
];

const MenuButton = styled.button<{
  solNum: number;
}>`
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    max-width: 5.5rem;
    transform: scale(1);
    transition: all 0.3s ease;
    &:hover {
      transform: scale(1.1);
      transition: all 0.3s ease;
    }
    &.active {
      transform: scale(1.15);
    }
  }
  p {
    font-size: 1rem;
  }
  position: absolute;
  left: ${({ solNum }) => buttonPositions[solNum].x};
  top: ${({ solNum }) => buttonPositions[solNum].y};

  @media only screen and (max-width: 576px) {
    img {
      // width: 2.75rem;
      width: 3.66rem
    }
  }
`;

const FlywheelGraphicWrap = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  // width: 100%;
  height: 30rem;
  img {
    width: 30rem;
    height: 30rem;
  }
  @media only screen and (max-width: 576px) {
    height: 20rem;
    img {
      height: 20rem;
      width: 20rem;
    }
  }
`;

const FlywheelMenu = ({
  solutions,
  currSol,
  setCurrSol,
}: {
  solutions: SolutionSectionInt[];
  currSol: number;
  setCurrSol: Dispatch<SetStateAction<number>>;
}) => {
  // console.log('solutions: ', solutions);
  const flywheelImgData = useStaticQuery(flywheelImageQuery).contentfulAsset;
  const flywheelImg = new Img(flywheelImgData);
  return (
    <Wrap>
      {solutions.map((sol, i) => {
        // console.log('sol: ', sol);
        const buttonImg = new Img(sol.leftColumnAnimatedBackgroundImage);
        const buttonImgOutlined = new Img(
          sol.rightColumnAnimatedBackgroundImage
        );
        const solTitle = sol.title.split("- ")[1];
        return (
          <MenuButton
            onClick={() => setCurrSol(i)}
            solNum={i}
            key={`solution-button-${i}`}
          >
            {currSol === i ? (
              <WmkImage image={buttonImgOutlined} className="active" />
            ) : (
              <WmkImage image={buttonImg} />
            )}
            <p>{solTitle}</p>
          </MenuButton>
        );
      })}
      <FlywheelGraphicWrap>
        <WmkImage image={flywheelImg} />
      </FlywheelGraphicWrap>
    </Wrap>
  );
};

export default FlywheelMenu;

const flywheelImageQuery = graphql`
  query {
    contentfulAsset(title: { eq: "Flywheel Graphic" }) {
      ...NodeImageFields
    }
  }
`;
